import { ConcurrentResourceLocker } from './concurrent-resource-locker.model';

export enum ConcurrentResourceType {
  APPOINTMENT = 'APPOINTMENT',
  TRADE = 'TRADE',
}

export type ConcurrentResourceRegistryByType = {
  [key in ConcurrentResourceType]?: ConcurrentResourceRegistry;
};

export interface ConcurrentResourceRegistry {[key: string]: ConcurrentResourceLocker;}

export class ConcurrentResource {
  type: ConcurrentResourceType;
  uuid: string;
}
